import React from 'react';

import { LoadingSpinner, Page } from '../../components/layouts';
import { LoginConfirmDialog } from '../../components/partials';
import {
  DispatchProps,
  StateProps,
} from '../../weborder/component/SmsCode/index';
import { RouteParams } from '../../weborder/Routes';

type Props = StateProps & DispatchProps & RouteParams;

export function LoginConfirm(props: Props): JSX.Element {
  const {
    AfterLogin: afterLoginUrl,
    allowGuestLogin,
    AppConfig: appConfig,
    DeviceId: deviceId,
    enableRememberMe,
    hasGdprCookieFeatureFlag,
    hCaptchaTokens,
    Login: login,
    params,
    rememberMe,
    setRememberMe,
    translate,
  } = props;

  if (appConfig.status !== 'success') {
    return <LoadingSpinner />;
  }

  return (
    <Page pageName="login-confirm">
      <LoginConfirmDialog
        afterLoginUrl={afterLoginUrl}
        allowGuestLogin={allowGuestLogin}
        configData={appConfig.data}
        deviceId={deviceId}
        enableRememberMe={enableRememberMe}
        hasGdprCookieFeatureFlag={hasGdprCookieFeatureFlag}
        hCaptchaTokens={hCaptchaTokens}
        login={login}
        params={params}
        rememberMe={rememberMe}
        setRememberMe={setRememberMe}
        translate={translate}
      />
    </Page>
  );
}
